import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { GetMembershipList, GetStateList, getUserDetails, updateExistingUserData, uploadFileService } from "../../api/common";
import moment from "moment";
import { deleteIcon, fbIcon, instagramIcon, linkedinIcon, pendingIcon, uploadIcon, uploadInlineIcon, youtubeIcon } from "../../assets/images";
import { truncateFilename } from "../../utils/commonFunction";
import { FACEBOOK_URL_REGEX, INSTAGRAM_URL_REGEX, LINKEDIN_URL_REGEX, PAN_REGEX, YOUTUBE_URL_REGEX } from "../../config/constant";
import { Form, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { tostE, tostS, tostW } from "../../config/tostConfig";
import { verifyMobileService, verifyOtpService } from "../../api/Register";
import Footer from "../common/Footer";
import OTPInput from "react-otp-input";
import OtpVerifyModal from "../ui/OtpVerifyModal";
import { Modal } from "../ui";
import { setUserData } from "../../redux/actions/authActions";

export default function ExistingMembershipForm() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user_id, from } = useParams();
  const {user} = useSelector((state) => state.auth);
  const [stateOption, setStateOption] = useState([]);
  const [mobileModal, setMobileModal] = useState(false);
  const [showMobileVerify, setShowMobileVerify] = useState(false);
  const [mobileotp, setMobileOtp] = useState("");
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [disclaimerAcknowledgement, setDisclaimerAcknowledgement] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentMembership, setCurrentMembership] = useState(null);
  const [data, setData] = useState({});
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [emailVerified, setEmailVerified] = useState(false);
  const [mobileVerified, setMobileVerified] = useState(false);


  const zoneOption = ["North", "East", "West", "South"];
  const companyTypeOption = [
    { value: "company", label: "Private Limited / Limited company" },
    { value: "partnership", label: "Partnership Firm / LLP" },
    { value: "huf", label: "Proprietor / HUF" }
  ];

  const getStateList = async (zone) => {
    try {
      const res = await GetStateList(zone);
      if (res.status === 200) {
        const respData = res.data;
        setStateOption(respData);
        if (data.state) {
          const isExist = respData.filter((item) => item.id.toString() === data.state.toString()).length > 0;
          if (!isExist) {
            setFieldValue("state", "");
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }


  const getUserData = async () => {
    setLoading(true);
    try {
      const uid = atob(user_id);
      const res = await getUserDetails(uid);
      if (res.status === 200) {
        const respData = res.data.data;
        if(respData.manual.toString() === "1" || respData.manual.toString() === "4"){
          getStateList(respData.zone);
          setData({
            ...respData.plan_history,
            ...respData,
            incorporation_date : (respData.org_type === "company" ? moment(respData.company.incorporation_date).format("YYYY-MM-DD") : respData.org_type === "partnership" ? moment(respData.llp.incorporation_date).format("YYYY-MM-DD") : ""),
          });
          setEmailVerified(true);
          setEmail(respData.email)
          if(respData.mobile_number){
            setMobile(respData.mobile_number);
            setMobileVerified(true);
          }
          const memRes = await GetMembershipList();
          if (memRes.status === 200 && memRes.data.success) {
            const list = memRes.data.data;
            const currentMem = list.find(item => item.id === respData.membership.id);
            setCurrentMembership(currentMem);
          }
        }else{
          navigate(`/user/update-details/${user_id}/thanks/1`, {replace:true});
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (user_id) {
      getUserData();
    }
  }, []); // eslint-disable-line

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("Email is required").email("Please enter a valid email"),
    dob: Yup.string().required("Date of birth is required"),
    mobile_number: Yup.string().required("Whatsapp number is required").min(6, "Please enter a valid number"),
    primary_number: Yup.string().required("Primary number is required").min(6, "Please enter a valid number"),
    state: Yup.string().required("State is required"),
    zone: Yup.string().required("Zone is required"),
    registered_address: Yup.string().required("Registered Office address is required"),
    size_of_company: Yup.string().when([], {
      is: () => (currentMembership && currentMembership?.name.toLowerCase() !== "star"),
      then: () => Yup.string().required("Size of company is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    incorporation_date: Yup.string().when(["org_type"], {
      is: (org_type) => (currentMembership && currentMembership?.name.toLowerCase() !== "star" && (org_type && org_type.toLowerCase() !== "huf")),
      then: () => Yup.string().required("Incorporation date is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    // GST number optional if membership is star
    gst_number: Yup.string().when([], {
      is: () => (currentMembership && currentMembership?.name.toLowerCase() !== "star"),
      then: () => Yup.string().required("GST number is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    pan_number: Yup.string().required("PAN number is required").matches(PAN_REGEX, "Please enter a valid PAN number"),
    org_type: Yup.string().when([], {
      is: () => (currentMembership && currentMembership?.name.toLowerCase() !== "star"),
      then: () => Yup.string().required("Company type is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    company_name: Yup.string().required("Company name is required"),
    moa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "company"))
      },
      then: () => Yup.string().required("MOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    aoa: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "company"))
      },
      then: () => Yup.string().required("AOA is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    portaldirector: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "company"))
      },
      then: () => Yup.string().required("Director Details is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    resolution: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "company"))
      },
      then: () => Yup.string().required("Resolution is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    incorporation_certificate: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "company"))
      },
      then: () => Yup.string().required("Incorporation certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    repersentative_photo: Yup.string().required("Representative photo is required"),
    deed: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "partnership"))
      },
      then: () => Yup.string().required("Deed is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "partnership"))
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    huf_authorization: Yup.string().when(["org_type"], {
      is: (org_type) => {
        return ((currentMembership && currentMembership?.name.toLowerCase() !== "star") && (org_type && org_type.toLowerCase() === "huf"))
      },
      then: () => Yup.string().required("Authorization is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    address_proof: Yup.string().required("Address proof is required"),
    turnover_certificate: Yup.string().when([], {
      is: () => (currentMembership && currentMembership?.name.toLowerCase() !== "star"),
      then: () => Yup.string().required("Turnover certificate is required"),
      otherwise: () => Yup.string().notRequired(),
    }),
    director: Yup.array()
      .of(Yup.object().shape({
        name: Yup.string().nullable()
          .test(
            "name-required-if-any",
            "Name is required",
            function (value) {
              const { email, mobile_number } = this.parent; // Access sibling fields
              return (!email && !mobile_number) || ((!!email || !!mobile_number) && !!value); // Name is required if email or mobile number exists
            }
          ),
        email: Yup.string().nullable()
          .email("Please enter a valid email")
          .test(
            "email-required-if-name",
            "Email is required",
            function (value) {
              const { name } = this.parent; // Access sibling fields
              return !name || (name && value); // Email is required if name exists
            }
          ),
        mobile_number: Yup.string().nullable()
          .min(6, "Please enter a valid mobile number")
          .test(
            "mobile-required-if-name",
            "Mobile number is required",
            function (value) {
              const { name } = this.parent; // Access sibling fields
              return !name || (name && value); // Mobile number is required if name exists
            }
          ),
      }))
      .test(
        "unique-email",
        "Email addresses must be unique",
        function (values) {
          if (!values || !values.length) return true;
          const emails = values.map((item) => item.email).filter(Boolean);
          const uniqueEmails = new Set(emails);
          return emails.length === uniqueEmails.size;
        }
      )
      .test(
        "unique-mobile-number",
        "Mobile numbers must be unique",
        function (values) {
          if (!values || !values.length) return true;
          const mobileNumbers = values.map((item) => item.mobile_number).filter(Boolean);
          const uniqueMobileNumbers = new Set(mobileNumbers);
          return mobileNumbers.length === uniqueMobileNumbers.size;
        }
      )
      .test(
        "not-users-email",
        "You can't use your email as director's Email address",
        function (values) {
          if (!values || !values.length) return true;
          const emails = values.map((item) => item.email).filter(Boolean);
          return !emails.includes(data.email);
        }
      )
      .test(
        "not-users-mobile-number",
        "You can't use your mobile number as director's mobile number",
        function (values) {
          if (!values || !values.length) return true;
          const mobileNumbers = values.map((item) => item.mobile_number).filter(Boolean);
          return !mobileNumbers.includes(data.mobile_number) && !mobileNumbers.includes(data.primary_number);
        }
      ),
    membership_checked: Yup.boolean()
      .oneOf([true], 'Please accept t&c.')
      .required('Membership check is required'),

    description: Yup.string().required("Description is required")
      .test(
        "min-words",
        "Description should be at least 100 words",
        (value) => value && value.trim().split(/\s+/).length >= 100)
      .test(
        "max-words",
        "Description should be less than 500 words",
        (value) => value && value.trim().split(/\s+/).length <= 500),
    meta: Yup.string().matches(FACEBOOK_URL_REGEX, "Please enter a valid URL"),
    linkedin: Yup.string().matches(LINKEDIN_URL_REGEX, "Please enter a valid URL"),
    instagram: Yup.string().matches(INSTAGRAM_URL_REGEX, "Please enter a valid URL"),
    youtube: Yup.string().matches(YOUTUBE_URL_REGEX, "Please enter a valid URL"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data.name ? data.name : "",
      email: data.email ? data.email : "",
      dob: data.dob ? data.dob : "",
      mobile_number: data.mobile_number ? data.mobile_number : "",
      state: data.state ? data.state : "",
      zone: data.zone ? data.zone : "",
      gst_number: data.gst_number ? data.gst_number : "",
      pan_number: data.pan_number ? data.pan_number : "",
      org_type: data.org_type ? data.org_type : "",
      company_name: data.company_name ? data.company_name : "",
      registered_address: data.registered_address ? data.registered_address : "",
      incorporation_date: data.incorporation_date ? data.incorporation_date : "",
      size_of_company: data.size_of_company ? data.size_of_company : "",
      primary_number: data.primary_number ? data.primary_number : "",
      same_number: data.same_number ? data.same_number : 0,
      moa: data.company && data.company.moa ? data.company.moa : "",
      aoa: data.company && data.company.aoa ? data.company.aoa : "",
      portaldirector: data.company && data.company.portaldirector ? data.company.portaldirector : "",
      resolution: data.company && data.company.resolution ? data.company.resolution : "",
      incorporation_certificate: data.incorporation_certificate ? data.incorporation_certificate : "",
      repersentative_photo: data.repersentative_photo ? data.repersentative_photo : "",
      deed: data.llp && data.llp.deed ? data.llp.deed : "",
      authorization: data.llp && data.llp.authorization ? data.llp.authorization : "",
      huf_deed: data.huf && data.huf.deed ? data.huf.deed : "",
      huf_authorization: data.huf && data.huf.authorization ? data.huf.authorization : "",
      address_proof: data.address_proof ? data.address_proof : "",
      turnover_certificate: data.turnover_certificate ? data.turnover_certificate : "",

      director: (data.director && data.director !== 'null') ? (typeof data.director === "string" ? JSON.parse(data.director) : data.director) : [{ name: "", email: "", mobile_number: "" }],

      description: data.description ? data.description : "",
      meta: data.meta ? data.meta : "",
      linkedin: data.linkedin ? data.linkedin : "",
      instagram: data.instagram ? data.instagram : "",
      youtube: data.youtube ? data.youtube : "",
      membership_checked: data.membership_checked === 1 ? true : false,
    },
    validationSchema,
    onSubmit: async (values) => {
      if (!mobileVerified || (values.mobile_number.toString() !== mobile.toString())) {
        tostW("Please verify your mobile number");
        return;
      }
      if (currentMembership && currentMembership?.name.toLowerCase() === "star" && (!values.gst_number || values.gst_number.trim() === "" || values.gst_number === null || values.gst_number === "null") && !disclaimerAcknowledgement) {
        setShowDisclaimer(true);
        return;
      }
      setLoading("submit");

      console.log(values);

      let formData = new FormData();

      formData.set("id", data.id);
      formData.set("name", values.name);
      formData.set("email", values.email);
      formData.set("dob", moment(values.dob).format("YYYY-MM-DD"));
      formData.set("mobile_number", values.mobile_number);
      formData.set("state", values.state);
      formData.set("zone", values.zone);
      formData.set("gst_number", values.gst_number);
      formData.set("pan_number", values.pan_number);
      formData.set("company_name", values.company_name);
      formData.set("registered_address", values.registered_address);
      formData.set("size_of_company", values.size_of_company);
      formData.set("primary_number", values.primary_number);
      formData.set("same_number", values.same_number);
      formData.set("membership_id", currentMembership && currentMembership.id ? currentMembership.id : "");

      if (currentMembership && currentMembership.name.toLowerCase() !== "star") {
        formData.set("org_type", values.org_type);
        formData.set("incorporation_date", moment(values.incorporation_date).format("YYYY-MM-DD"));
        formData.set("turnover_certificate", values.turnover_certificate);
        if (values.org_type.toLowerCase() === "company") {
          formData.set("moa", values.moa);
          formData.set("aoa", values.aoa);
          formData.set("portaldirector", values.portaldirector);
          formData.set("resolution", values.resolution);
          formData.set("incorporation_certificate", values.incorporation_certificate);
        }
        if (values.org_type.toLowerCase() === "partnership") {
          formData.set("deed", values.deed);
          formData.set("authorization", values.authorization);
        }
        if (values.org_type.toLowerCase() === "huf") {
          formData.set("deed", values.huf_deed);
          formData.set("authorization", values.huf_authorization);
        }
      }
      formData.set("repersentative_photo", values.repersentative_photo);
      formData.set("address_proof", values.address_proof);

      formData.set("director", ((values.director).filter((item) => item.name !== "" && item.email !== "" && item.mobile_number !== "").length && currentMembership && currentMembership.name.toLowerCase() !== "star") ? JSON.stringify(values.director) : null);

      formData.set("description", values.description);
      formData.set("meta", values.meta);
      formData.set("linkedin", values.linkedin);
      formData.set("instagram", values.instagram);
      formData.set("youtube", values.youtube);
      formData.set("membership_checked", values.membership_checked ? 1 : 0);

      try {
        const res = await updateExistingUserData(formData);
        if(res.status === 200 && res.data.success){
          tostS(res.data.message);
          if(from && from === "renew"){
            dispatch(setUserData({...user, manual: 2}));
            navigate(`/app/checkout/${btoa(res.data.app_id)}`, { replace: true });
          }else{
            navigate(`/user/update-details/${user_id}/thanks/0`, {replace:true});
          }
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        tostE("Something went wrong");
        console.log(error);
      } finally {
        setLoading("");
      }

    },
  });

  const { values, errors, touched, getFieldProps, setFieldValue, setFieldTouched, setValues, handleSubmit } = formik;
  console.log(errors);
  const handleFileUpload = async (e) => {
    const fieldName = e.target.name;
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    const validFileTypes = {
      address_proof: ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'],
      repersentative_photo: ['image/jpeg', 'image/png', 'image/jpg'],
      default: ['application/pdf'],
    };

    const allowedTypes = validFileTypes[fieldName] || validFileTypes.default;
    if (!allowedTypes.includes(file.type)) {
      tostW(`Only ${allowedTypes.map((type) => type.split('/')[1].toUpperCase()).join(', ')} files are allowed.`);
      return;
    }

    // Validate file size (5 MB)
    const maxSizeInBytes = 5 * 1024 * 1024;
    const turnoverMaxSizeInBytes = 20 * 1024 * 1024;
    if (fieldName === "turnover_certificate" && file.size > turnoverMaxSizeInBytes) {
      tostW('File size must upto 20 MB.');
      return;
    } else if (file.size > maxSizeInBytes) {
      tostW('File size must be upto 5 MB.');
      return;
    }

    // Prepare form data for file upload
    const body = new FormData();
    body.append("file", file);
    if (values[fieldName]) {
      body.append("old_file_name", values[fieldName].split(".com").pop());
    }

    try {
      const fileResponse = await uploadFileService(body);
      if (fileResponse.status === 200 && fileResponse.data.success) {
        const uploadedFileUrl = fileResponse.data.url;
        setFieldValue(fieldName, uploadedFileUrl);
      }
    } catch (error) {
      console.error(error);
      tostW("Error uploading file");
    }
  };


  const handleVerifyMobile = async () => {
    if (loading === "verify_mobile") return;
    if (values.mobile_number && values.mobile_number.toString().length >= 6) {
      setLoading("verify_mobile");
      try {
        const res = await verifyMobileService(values.mobile_number);
        if (res.status === 200 && res.data.success) {
          setMobileModal(true);
        } else {
          tostW(res.data.message);
        }
      } catch (error) {
        tostE(error.message);
      } finally {
        setLoading("");
      }
    } else {
      setFieldTouched("mobile_number", true);
    }
  };

  const handleVerifyOtp = async (type) => {
    if (loading === "verify_email_otp" || loading === "verify_mobile_otp") return;

    if (type === "mobile") {
      if (!mobileotp || mobileotp.toString().length < 4) {
        tostW("Please enter a valid OTP");
        return;
      }
      const body = {
        mobile_number: values.mobile_number,
        otp: mobileotp
      }
      setLoading("verify_mobile_otp");
      try {
        const res = await verifyOtpService(body);
        if (res.status === 200 && res.data.success) {
          setMobile(values.mobile_number);
          setMobileVerified(true);
          setMobileModal(false);
        } else {
          setShowMobileVerify(true);
          tostW("OTP verification failed");
        }
      } catch (error) {
        setShowMobileVerify(true);
        console.log(error);
      } finally {
        setLoading("");
      }
    }
  }

  const handleAddInput = () => {
    const updatedDirector = [...values.director, { name: "", email: "", mobile_number: "" }];

    setValues({
      ...values,
      director: updatedDirector,
    });
  };

  const handleInputChange = (e, idx) => {
    const { name, value } = e.target;
    const updatedDirector = values.director.map((director, index) =>
      index === idx ? { ...director, [name]: value } : director
    );
    setValues({
      ...values,
      director: updatedDirector,
    });
  };

  const handleDeleteInput = (index) => {
    const updatedDirector = values.director.filter((_, idx) => idx !== index);

    setValues({
      ...values,
      director: updatedDirector,
    });

  };

  useEffect(() => {
    if (mobileotp && mobileotp.toString().length === 4) {
      if (mobileModal) {
        handleVerifyOtp("mobile");
      }
    }
  }, [mobileotp]) // eslint-disable-line


  return (
    <>
      <div className={"wrapper fullWidth"}>
        <div className="customContainer">
          <div className="headingTexts ">
            <h2>Membership Form</h2>
            <p>
              you are applying under{" "}
              <span style={{ fontWeight: "600" }}>{(currentMembership?.name && !loading) ? currentMembership?.name : ""} Membership</span>
            </p>
          </div>

          <div className="membershipForm">
            <FormikProvider value={formik}>
              <Form onSubmit={handleSubmit}>
                <div className="my-3">
                  <h5 className="">Basic Details</h5>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Full Name"
                        name="name"
                        value={values.name}
                        disabled={data.name}
                        onChange={(e) => {
                          setFieldValue("name", e.target.value);
                        }}
                      />
                      {touched.name && errors.name && (
                        <div className="error">{errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className={"verifyLabel "}>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email Address"
                          name="email"
                          disabled={data.email}
                          value={values.email}
                          onChange={(e) => {
                            setFieldValue("email", e.target.value);
                          }}
                        />
                        <span onClick={() => {
                        }} className={"textVerify " + (loading === "verify_email" ? " loading" : "") + ((emailVerified && (values.email === email)) ? " success" : "")}>
                          {(emailVerified && (values.email === email)) ? "Verified" : "Verify"}
                          {loading === "verify_email" && <div className="spinner-border text-light" style={{ width: "1rem", height: "1rem", marginLeft: "5px" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>}
                        </span>
                      </div>
                      {touched.email && errors.email && (
                        <div className="error">{errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        className="form-control customDatePicker"
                        type={data.dob ? "date" : "text"}
                        // disabled={(id) ? true : false}
                        name="dob"
                        autoComplete="off"
                        value={values.dob ? values.dob : ""}
                        onChange={(e) => {
                          if (e.target.value.length > 10) return;
                          setFieldValue("dob", e.target.value);
                        }}
                        placeholder="Date of Birth (DD/MM/YYYY)"
                        aria-label="select date of birth"
                        onFocus={(e) => {
                          if (e.target.value) {
                            e.target.type = "date"
                          } else {
                            e.target.type = "date"
                          }
                        }}
                        onBlur={(e) => {
                          if (!e.target.value) {
                            e.target.type = "text"
                          } else {
                            e.target.type = "date"
                          }
                        }}
                      />
                      {touched.dob && errors.dob && (
                        <div className="error">{errors.dob}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className={"verifyLabel "}>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Whatsapp Number"
                          name="mobile_number"
                          disabled={values.same_number === 1}
                          value={values.mobile_number}
                          onChange={(e) => {
                            if (e.target.value.toString().length > 15) {
                              return;
                            }
                            setFieldValue("mobile_number", e.target.value);
                            if (values.same_number) {
                              setFieldValue("primary_number", e.target.value);
                            }
                          }}
                        />
                        <span onClick={() => handleVerifyMobile()} className={"textVerify " + (loading === "verify_mobile" ? " loading" : "") + ((mobileVerified && (values.mobile_number.toString() === mobile.toString())) ? " success" : "")}>
                          {(mobileVerified && (values.mobile_number.toString() === mobile.toString())) ? "Verified" : "Verify"}
                          {loading === "verify_mobile" && <div className="spinner-border text-light" style={{ width: "1rem", height: "1rem", marginLeft: "5px" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                          </div>}
                        </span>
                      </div>
                      {touched.mobile_number && errors.mobile_number && (
                        <div className="error">{errors.mobile_number}</div>
                      )}
                      <span className="form-check numberCheck">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="inlineCheckbox1"
                          name="same_number"
                          // disabled={(id) ? true : false}
                          checked={values.same_number === 1}
                          onChange={(e) => {
                            if (!values.primary_number || values.primary_number.toString() === "") {
                              tostW("Please enter your whatsapp number first.");
                              return;
                            }
                            setFieldValue("same_number", e.target.checked ? 1 : 0);
                            if (e.target.checked) {
                              setFieldValue("mobile_number", values.primary_number);
                            } else {
                              setFieldValue("mobile_number", "");
                            }
                          }}
                        />
                        <label className="form-check-label" htmlFor="inlineCheckbox1">
                          Whatsapp Mobile Number is same as Primary Number.
                        </label>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className={"verifyLabel "}>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Primary Mobile Number"
                          name="primary_number"
                          disabled={values.primary_number}
                          value={values.primary_number}
                          onChange={(e) => {
                            if (e.target.value.toString().length > 15) {
                              return;
                            }
                            setFieldValue("primary_number", e.target.value);
                          }}
                        />
                      </div>
                      {touched.primary_number && errors.primary_number && (
                        <div className="error">{errors.primary_number}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="customSelect">
                        <select
                          className={"form-control " + (values.zone ? "" : " not-selected")}
                          name={"zone"}
                          value={values.zone}
                          onChange={(e) => {
                            setFieldValue("zone", e.target.value);
                          }}
                          disabled={data.zone}
                        >
                          <option value="">{"Select Zone"}</option>
                          {zoneOption.map((option, idx) => (
                            <option key={idx} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                      {touched.zone && errors.zone && (
                        <div className="error">{errors.zone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="customSelect">
                        <select
                          className={"form-control " + (values.state ? "" : " not-selected")}
                          name={"state"}
                          value={values.state}
                          onChange={(e) => {
                            setFieldValue("state", e.target.value);
                          }}
                          disabled={values.state && values.state === data.state}
                        >
                          <option value="">Select State</option>
                          {stateOption.map((option, idx) => (
                            <option key={idx} value={option.id}>
                              {option.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {touched.state && errors.state && (
                        <div className="error">{errors.state}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={"GST Number" + (currentMembership?.name.toString().toLowerCase() === 'star' ? " (Optional)" : "")}
                        name="gst_number"
                        disabled={data.gst_number}
                        value={values.gst_number}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase().trim();
                          if (value.length > 15) return
                          setFieldValue("gst_number", value);
                        }}
                      />
                      {touched.gst_number && errors.gst_number && (
                        <div className="error">{errors.gst_number}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="PAN Number"
                        name="pan_number"
                        value={values.pan_number}
                        disabled={data.pan_number}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase().trim();
                          if (value.length > 10) return
                          setFieldValue("pan_number", value);
                        }}
                      />
                      {touched.pan_number && errors.pan_number && (
                        <div className="error">{errors.pan_number}</div>
                      )}
                    </div>
                  </div>
                  {currentMembership && currentMembership?.name.toString().toLowerCase() !== 'star' &&
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customSelect">
                            <select
                              className={"form-control " + (values.org_type ? "" : " not-selected")}
                              name={"org_type"}
                              value={values.org_type}
                              onChange={(e) => {
                                setFieldValue("org_type", e.target.value);
                              }}
                              disabled={data.org_type}
                            >
                              <option value="">{"Select Company Type"}</option>
                              {companyTypeOption.map((option, idx) => (
                                <option key={idx} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                          {touched.org_type && errors.org_type && (
                            <div className="error">{errors.org_type}</div>
                          )}
                        </div>
                      </div>
                      {(values.org_type && values.org_type !== "huf") &&
                        <div className="col-md-6">
                          <div className="form-group">
                            <input
                              className="form-control customDatePicker"
                              type={data.incorporation_date ? "date" : "text"}
                              // disabled={(id) ? true : false}
                              name="incorporation_date"
                              autoComplete="off"
                              value={values.incorporation_date ? values.incorporation_date : ""}
                              onChange={(e) => {
                                if (e.target.value.length > 10) return;
                                setFieldValue("incorporation_date", e.target.value);
                              }}
                              placeholder="Incorporation Date (DD/MM/YYYY)"
                              aria-label="select Incorporation Date"
                              onFocus={(e) => {
                                if (e.target.value) {
                                  e.target.type = "date"
                                } else {
                                  e.target.type = "date"
                                }
                              }}
                              onBlur={(e) => {
                                if (!e.target.value) {
                                  e.target.type = "text"
                                } else {
                                  e.target.type = "date"
                                }
                              }}
                            />
                            {touched.incorporation_date && errors.incorporation_date && (
                              <div className="error">{errors.incorporation_date}</div>
                            )}
                          </div>
                        </div>}
                    </>}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Company Name"
                        name="company_name"
                        value={values.company_name}
                        onChange={(e) => {
                          setFieldValue("company_name", e.target.value);
                        }}
                        disabled={data.company_name}
                      />
                      {touched.company_name && errors.company_name && (
                        <div className="error">{errors.company_name}</div>
                      )}
                    </div>
                  </div>
                  {(currentMembership && currentMembership?.name.toString().toLowerCase() !== 'star') &&
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customSelect">
                          <select
                            className={"form-control " + (values.size_of_company ? "" : " not-selected")}
                            name={"size_of_company"}
                            value={values.size_of_company}
                            onChange={(e) => {
                              setFieldValue("size_of_company", e.target.value);
                            }}
                            disabled={data.size_of_company}
                          >
                            <option value="">{"Select Company Size"}</option>
                            {["1-25", "25-50", "50 & above"].map((option, idx) => (
                              <option key={idx} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        {touched.size_of_company && errors.size_of_company && (
                          <div className="error">{errors.size_of_company}</div>
                        )}
                      </div>
                    </div>}
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Registered Office Address"
                        name="registered_address"
                        value={values.registered_address}
                        disabled={data.registered_address}
                        onChange={(e) => {
                          setFieldValue("registered_address", e.target.value);
                        }}
                      />
                      {touched.registered_address && errors.registered_address && (
                        <div className="error">{errors.registered_address}</div>
                      )}
                    </div>
                  </div>
                  {(currentMembership && currentMembership?.name.toString().toLowerCase() !== 'star') && values.org_type === "company" &&
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="moa"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.moa ? (values.moa.name || values.moa.split("/").pop()) : "Upload MOA"}
                            />
                            <span>
                              <p>{values.moa ? truncateFilename(values.moa.name || values.moa.split("/").pop()) : "Upload MOA"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.moa && errors.moa && (
                            <div className="error">{errors.moa}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="aoa"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.aoa ? (values.aoa.name || values.aoa.split("/").pop()) : "Upload AOA"}
                            />
                            <span>
                              <p>{values.aoa ? truncateFilename(values.aoa.name || values.aoa.split("/").pop()) : "Upload AOA"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.aoa && errors.aoa && (
                            <div className="error">{errors.aoa}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="portaldirector"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.portaldirector ? (values.portaldirector.name || values.portaldirector.split("/").pop()) : "Director details from MCA Portal"}
                            />
                            <span>
                              <p>{values.portaldirector ? truncateFilename(values.portaldirector.name || values.portaldirector.split("/").pop()) : "Director details from MCA Portal"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.portaldirector && errors.portaldirector && (
                            <div className="error">{errors.portaldirector}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="resolution"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.resolution ? (values.resolution.name || values.resolution.split("/").pop()) : "Board Resolution"}
                            />
                            <span>
                              <p>{values.resolution ? truncateFilename(values.resolution.name || values.resolution.split("/").pop()) : "Board Resolution"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.resolution && errors.resolution && (
                            <div className="error">{errors.resolution}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="incorporation_certificate"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.incorporation_certificate ? (values.incorporation_certificate.name || values.incorporation_certificate.split("/").pop()) : "Incorporation Certificate"}
                            />
                            <span>
                              <p>{values.incorporation_certificate ? truncateFilename(values.incorporation_certificate.name || values.incorporation_certificate.split("/").pop()) : "Incorporation Certificate"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.incorporation_certificate && errors.incorporation_certificate && (
                            <div className="error">{errors.incorporation_certificate}</div>
                          )}
                        </div>
                      </div>
                    </>}
                  {(currentMembership && currentMembership?.name.toString().toLowerCase() !== 'star') && (values.org_type === "partnership") &&
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="deed"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.deed ? (values.deed.name || values.deed.split("/").pop()) : "Partnership Deed"}
                            />
                            <span>
                              <p>{values.deed ? truncateFilename(values.deed.name || values.deed.split("/").pop()) : "Partnership Deed"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.deed && errors.deed && (
                            <div className="error">{errors.deed}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="authorization"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.authorization ? (values.authorization.name || values.authorization.split("/").pop()) : "Authorization Letter"}
                            />
                            <span>
                              <p>{values.authorization ? truncateFilename(values.authorization.name || values.authorization.split("/").pop()) : "Authorization Letter"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.authorization && errors.authorization && (
                            <div className="error">{errors.authorization}</div>
                          )}
                        </div>
                      </div>
                    </>}
                  {(currentMembership && currentMembership?.name.toString().toLowerCase() !== 'star') && (values.org_type === "huf") &&
                    <>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="huf_deed"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.huf_deed ? (values.huf_deed.name || values.huf_deed.split("/").pop()) : "HUF Deed"}
                            />
                            <span>
                              <p>{values.huf_deed ? truncateFilename(values.huf_deed.name || values.huf_deed.split("/").pop()) : "HUF Deed"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.huf_deed && errors.huf_deed && (
                            <div className="error">{errors.huf_deed}</div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <div className="customFile inline">
                            <input
                              name="huf_authorization"
                              onChange={(e) => handleFileUpload(e)}
                              className="form-control"
                              type="file"
                              accept="application/pdf"
                              title={values.huf_authorization ? (values.huf_authorization.name || values.huf_authorization.split("/").pop()) : "Authorization Letter"}
                            />
                            <span>
                              <p>{values.huf_authorization ? truncateFilename(values.huf_authorization.name || values.huf_authorization.split("/").pop()) : "Authorization Letter"}</p>
                              <small>Please upload only pdf files (Max size: 5MB)</small>
                            </span>
                            <img src={uploadInlineIcon} alt="" />
                          </div>
                          {touched.huf_authorization && errors.huf_authorization && (
                            <div className="error">{errors.huf_authorization}</div>
                          )}
                        </div>
                      </div>
                    </>}
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className={"customFile inline"}>
                        <input
                          // disabled={(id) ? true : false} 
                          name="repersentative_photo"
                          onChange={(e) => handleFileUpload(e)}
                          className="form-control"
                          type="file"
                          accept="image/*"
                          title={values.repersentative_photo ? values.repersentative_photo.name || values.repersentative_photo.split("/").pop() : "Representative Photo"}
                        />
                        <span>
                          <p>{values.repersentative_photo ? truncateFilename(values.repersentative_photo.name || values.repersentative_photo.split("/").pop()) : "Representative Photo"}</p>
                          <small>Allowed formats: .jpg, .jpeg, .png (Max size: 5MB)</small>
                        </span>
                        <img src={uploadInlineIcon} alt="" />
                      </div>
                      {touched.repersentative_photo && errors.repersentative_photo && (
                        <div className="error">{errors.repersentative_photo}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className={currentMembership?.name.toString().toLowerCase() === "star" ? "col-md-12" : "col-md-6"}>
                    <div className="form-group">
                      <div className="customFile">
                        <input
                          name="address_proof"
                          accept="image/*,application/pdf"
                          onChange={(e) => handleFileUpload(e)}
                          className="form-control"
                          type="file"
                          title={values.address_proof ?
                            (values.address_proof.name || values.address_proof.split("/").pop())
                            : "Rental Agreement / GST Certificate / Electricity / Broadband Bill"}
                        />
                        <img src={uploadIcon} alt="" />
                        <h4>Address Proof</h4>
                        <small className="mb-2">Allowed formats: .jpg, .jpeg, .png, .pdf (Max size: 5MB)</small>
                        <p>
                          {values.address_proof ?
                            truncateFilename(values.address_proof.name || values.address_proof.split("/").pop(), 15, 15)
                            : "Rental Agreement / GST Certificate / Electricity / Broadband Bill"}
                        </p>
                      </div>
                      {touched.address_proof && errors.address_proof && (
                        <div className="error">{errors.address_proof}</div>
                      )}
                    </div>
                  </div>
                  {currentMembership?.name.toString().toLowerCase() !== "star" &&
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="customFile">
                          <input
                            title={values.turnover_certificate ?
                              truncateFilename(values.turnover_certificate.name || values.turnover_certificate.split("/").pop(), 15, 15)
                              : "Upload CA Certificate / last 2 year ITR, P&L Balance Sheet"}
                            name="turnover_certificate"
                            onChange={(e) => handleFileUpload(e)}
                            className="form-control"
                            type="file"
                            accept="application/pdf"
                          />
                          <img src={uploadIcon} alt="" />
                          <h4>Company Turnover</h4>
                          <small className="mb-2">Please upload only pdf files (Max size: 20MB)</small>
                          <p>
                            {values.turnover_certificate ?
                              (values.turnover_certificate.name || values.turnover_certificate.split("/").pop())
                              : "Upload CA Certificate / last 2 year ITR, P&L Balance Sheet"}
                          </p>
                        </div>
                        {touched.turnover_certificate && errors.turnover_certificate && (
                          <div className="error">{errors.turnover_certificate}</div>
                        )}
                      </div>
                    </div>}
                </div>

                <hr />
                {(!(currentMembership && currentMembership?.name.toLowerCase() === "star")) && (<>
                <div className="director-info my-3">
                  <h5 className="">Director Details</h5>
                </div>
                {(values.director && Array.isArray(values.director) && values.director.length) && values.director.map((item, idx) => (
                  <div key={idx} className="row mb-3">
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          value={item.name}
                          placeholder="Director Name"
                          name="name"
                          onChange={(e) => { handleInputChange(e, idx) }}
                        />
                        {Array.isArray(touched.director) && touched.director.length && touched.director[idx]?.name && Array.isArray(errors.director) && errors.director.length && errors.director[idx]?.name && <p className="error">{errors.director[idx].name}</p>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control"
                          value={item.mobile_number}
                          placeholder="Mobile"
                          name="mobile_number"
                          onChange={(e) => {
                            if (e.target.value.length > 15) return
                            handleInputChange(e, idx)
                          }}
                        />
                        {Array.isArray(touched.director) && touched.director.length && touched.director[idx]?.mobile_number && Array.isArray(errors.director) && errors.director.length && errors.director[idx]?.mobile_number && <p className="error">{errors.director[idx].mobile_number}</p>}
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          value={item.email}
                          placeholder="Email"
                          name="email"
                          onChange={(e) => { handleInputChange(e, idx) }}
                        />
                        {Array.isArray(touched.director) && touched.director.length && touched.director[idx]?.email && Array.isArray(errors.director) && errors.director.length && errors.director[idx]?.email && <p className="error">{errors.director[idx].email}</p>}
                      </div>
                    </div>
                    <div className="col-md-2">
                      {values.director.length > 1 &&
                        <button
                          className="btn btn-primary deleteBtn"
                          onClick={() => handleDeleteInput(idx)}
                          type="button"
                        >
                          <img src={deleteIcon} alt="delete-icon" />
                        </button>}
                    </div>
                  </div>
                ))}
                {touched.director && errors.director && typeof (errors.director) === "string" && <p className="error mb-2">{errors.director}</p>}
                {values.director.length < 5 &&
                  <button
                    type="button"
                    className="btn btn-dark add-new"
                    onClick={handleAddInput}
                    disabled={values.director.length > 4}
                  >
                    Add New
                  </button>}
                <hr />
                </>)}


                <div className="my-3">
                  <h5>Other Details</h5>
                </div>

                <div className="form-group">
                  <textarea
                    className="form-control textarea"
                    placeholder="Tell us about yourself/company in max 500 words"
                    name="description"
                    value={values.description}
                    onChange={(e) => {
                      formik.setFieldValue("description", e.target.value);
                    }}
                  />
                  <div className={"d-flex justify-content-between" + (values.description.trim().split(/\s+/).length > 500 ? " error" : "")}>
                    <span className="input-char-count">
                      {values.description ? values.description.trim().split(/\s+/).length : 0}/{values.description.trim().split(/\s+/).length <= 100 ? 100 : 500}
                    </span>
                    {values.description.trim().split(/\s+/).length > 500 &&
                      <span className="input-char-count">
                        {values.description.trim().split(/\s+/).length - 500} words exceeded
                      </span>}
                  </div>
                  {touched.description && errors.description && <div className="error">{errors.description}</div>}
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="socialLinksInput">
                        <span className="icon">
                          <img src={fbIcon} alt="" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="https://"
                          name="meta"
                          value={values.meta}
                          onChange={(e) => {
                            formik.setFieldValue("meta", e.target.value);
                          }}
                        />
                      </div>
                      {touched.meta && errors.meta && <div className="error">{errors.meta}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="socialLinksInput">
                        <span className="icon">
                          <img src={linkedinIcon} alt="" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="https://"
                          name="linkedin"
                          value={values.linkedin}
                          onChange={(e) => {
                            formik.setFieldValue("linkedin", e.target.value);
                          }}
                        />
                      </div>
                      {touched.linkedin && errors.linkedin && <div className="error">{errors.linkedin}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="socialLinksInput">
                        <span className="icon">
                          <img src={instagramIcon} alt="" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="https://"
                          name="instagram"
                          value={values.instagram}
                          onChange={(e) => {
                            formik.setFieldValue("instagram", e.target.value);
                          }}
                        />
                      </div>
                      {touched.instagram && errors.instagram && <div className="error">{errors.instagram}</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <div className="socialLinksInput">
                        <span className="icon">
                          <img src={youtubeIcon} alt="" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="https://"
                          name="youtube"
                          value={values.youtube}
                          onChange={(e) => {
                            formik.setFieldValue("youtube", e.target.value);
                          }}
                        />
                      </div>
                      {touched.youtube && errors.youtube && <div className="error">{errors.youtube}</div>}
                    </div>
                  </div>
                </div>
                <div className="form-check form-check-inline eligibleText">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="inlineCheckbox11"
                    name="membership_checked"
                    checked={values.membership_checked}
                    {...getFieldProps('membership_checked')}
                  />
                  <label className="form-check-label" htmlFor="inlineCheckbox11">
                  I/We confirm that the submitted details are true and accurate. 
                  If ineligible for the selected membership, we agree to apply for the appropriate category. 
                  I also acknowledge that the membership fee must be paid online, and any direct bank deposits will be refunded.
                  </label>
                  {touched.membership_checked && errors.membership_checked && <p className="error">{errors.membership_checked}</p>}
                </div>
              </Form>
            </FormikProvider>
          </div>
          <Footer
            hideBackButton={true}
            className={"justify-content-end"}
            isBackAllowed
            isNextAllowed={loading !== "submit" && values.membership_checked}
            isSaveAsDraft={false}
            nextButtonText={() => (
              <>
                {loading === "submit" && <div className="spinner-border text-secondary" style={{ width: "1rem", height: "1rem", marginRight: "5px" }} role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>}
                Submit
              </>
            )}
            nextButtonAction={() => {
              handleSubmit();
            }}
          />
          {mobileModal &&
            <OtpVerifyModal
              footerActionActive={mobileotp.length === 4 && loading !== "verify_mobile_otp"}
              footerAction={() => handleVerifyOtp("mobile")}
              handleCloseModal={() => {
                setMobileModal(false);
                setMobileOtp("");
              }}
              showFooterAction={showMobileVerify}
            >
              <h5 className="modal-title text-center">Verify Number</h5>
              <p className="text-center">Your OTP sent on your <br /> Phone Number {values.mobile_number}</p>
              <OTPInput
                value={mobileotp}
                onChange={setMobileOtp}
                renderInput={(props) => (
                  <div className="form-group">
                    <input {...props} />
                  </div>
                )}
                containerStyle={"optInputGroups"}
                inputStyle={"form-control"}
                shouldAutoFocus
                placeholder="----"
                inputType="number"
              />
            </OtpVerifyModal>}
          {showDisclaimer &&
            <Modal
              className="save-draft-modal "
              modalTitle="Confirmation"
              handleCloseModal={() => {
                setShowDisclaimer(false);
                setDisclaimerAcknowledgement(true);
              }}
              footerAction={() => {
                setShowDisclaimer(false);
                setDisclaimerAcknowledgement(true);
              }}
              footerActionActive
              footerActionText="Okay"
            >
              <img src={pendingIcon} alt="" />
              <h6 className="text-center">GST Information Required for Invoice</h6>
              <p className="text-center">Leaving the GST field blank means a GST invoice will not be issued for your Star Membership plan. Please ensure this aligns with your requirements.</p>
            </Modal>}
        </div>
      </div>
    </>
  );
}
